import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { loadRuntimeConfig } from './config/runtime-config';

async function bootstrap(): Promise<void> {
    await loadRuntimeConfig();

    if (environment.production) {
        enableProdMode();
    }
    const firebaseApp = initializeApp(environment.firebaseConfig);
    getAuth(firebaseApp).tenantId = environment.firebaseTenantId;

    // Set company check
    localStorage.setItem('company', environment.companyCheck ?? 'default');

    await platformBrowserDynamic().bootstrapModule(AppModule);
}

bootstrap().catch((err) => {
    console.error('Unable to load frontend runtime configuration', err);
    document.body.innerHTML = '<main style="font-family: sans-serif; padding: 2rem"><h1>Application configuration unavailable</h1><p>Please try again later.</p></main>';
});
